  import { environment } from 'src/environments/environment';

  declare global {
    interface Window {
      branch: any;
    }
  }
  class BranchService {
    loadScript() {
      return new Promise<void>((resolve, reject) => {
        (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener banner closeBanner closeJourney data deepview deepviewCta first init link logout removeListener setBranchViewData setIdentity track trackCommerceEvent logEvent disableTracking getBrowserFingerprintId crossPlatformIds lastAttributedTouchData setAPIResponseCallback qrCode setRequestMetaData setAPIUrl getAPIUrl setDMAParamsForEEA".split(" "), 0);
        resolve();
      });
    }

    init() {
      window.branch.init(environment.branchKey, function(err, data) {
        
      });
    }

    banner() {
      window.branch.banner({
        title: '앱으로 열기',
        description: '앱이 설치되어 있으면 바로 열립니다!',
        openAppButtonText: '열기',
        showDesktop: false,
      });
    }
  }
  
  export default new BranchService();